import PageBanner from "@/components/feature/PageBanner";

const policySections = [
  {
    id: "shipping",
    icon: "ri-truck-line",
    title: "Shipping",
    content: (
      <>
        <p className="text-foreground-600 leading-relaxed mb-4">
          We charge a flat shipping fee of <strong className="text-foreground-900">₹30</strong> on every
          order, anywhere in India. No surprises, no variable rates — just one
          simple, transparent shipping cost no matter where you are.
        </p>
        <p className="text-foreground-600 leading-relaxed mb-4">
          Orders are processed and dispatched within <strong className="text-foreground-900">1–2 business
          days</strong> of confirmation. Once your order leaves our Meerut
          facility, you will receive tracking details so you can follow your
          package's journey.
        </p>
        <p className="text-foreground-600 leading-relaxed">
          Delivery typically takes <strong className="text-foreground-900">5–7 business days</strong> depending
          on your location. Remote areas may take slightly longer. If your order
          hasn't arrived within the expected window, reach out to us on
          WhatsApp or email and we will look into it right away.
        </p>
      </>
    ),
  },
  {
    id: "returns",
    icon: "ri-arrow-go-back-line",
    title: "Returns & Exchange",
    content: (
      <>
        <p className="text-foreground-600 leading-relaxed mb-4">
          We offer a simple <strong className="text-foreground-900">7-day easy return</strong> policy. If you
          are not completely happy with your purchase, you can return it within
          7 days of delivery for a full refund — no questions asked.
        </p>
        <p className="text-foreground-600 leading-relaxed mb-4">
          Exchanges are available for <strong className="text-foreground-900">size issues or manufacturing
          defects</strong>. If you need a different size or received a piece with a
          flaw, we will replace it at no extra cost. Just reach out within 7
          days and we will guide you through the exchange process.
        </p>
        <p className="text-foreground-600 leading-relaxed">
          To be eligible for a return or exchange, items must be <strong className="text-foreground-900">unused,
          unwashed, and with all original tags attached</strong>. Once we receive
          and inspect the returned item, your refund will be processed within
          3–5 business days.
        </p>
      </>
    ),
  },
  {
    id: "privacy",
    icon: "ri-shield-check-line",
    title: "Privacy",
    content: (
      <p className="text-foreground-600 leading-relaxed">
        Your privacy matters to us. We collect only the information necessary
        to process and deliver your order — your name, phone number, shipping
        address, and payment details. We do not sell, share, or rent your
        personal information to third parties. Payment information is processed
        securely and is never stored on our servers. If you have any questions
        about how your data is handled, please reach out via WhatsApp or our
        contact form.
      </p>
    ),
  },
];

export default function Policies() {
  return (
    <div>
      <PageBanner
        title="Our Policies"
        subtitle="Shipping, returns, and privacy — everything you need to know."
        bgImage="/images/policies-banner.jpg"
      />

      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <div className="flex flex-col gap-8">
              {policySections.map((section) => (
                <div
                  key={section.id}
                  id={section.id}
                  className="bg-background-100 rounded-2xl p-6 md:p-10 shadow-sm border border-background-200/70 scroll-mt-24"
                >
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                      <i
                        className={`${section.icon} w-5 h-5 flex items-center justify-center text-lg`}
                      />
                    </div>
                    <h2 className="font-heading text-xl md:text-2xl font-semibold text-accent-800">
                      {section.title}
                    </h2>
                  </div>
                  <div className="text-sm md:text-base">{section.content}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}